import ErrorStatus from '$shared/constants/ErrorStatus';
import UIErrorMessage from '$shared/constants/UIErrorMessage';
import { ErrorMessage } from '$shared/models/ErrorMessage';
import type { ErrorStatusMapping } from '.';

class DatasetError {
  public getMetadata(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        UIErrorMessage.FailedToGetDatasetMetadata,
        true
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        UIErrorMessage.MissingPermissionToGetDatasetMetadata,
        true
      ),
      [ErrorStatus.NotFound]: ErrorMessage.create(UIErrorMessage.FailedToGetDatasetMetadata, true)
    };
  }

  public getMetadataList(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        `${UIErrorMessage.FailedToGetDatasetMetadata} list`,
        true
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        `${UIErrorMessage.MissingPermissionToGetDatasetMetadata} list`,
        true
      ),
      [ErrorStatus.NotFound]: ErrorMessage.create(
        `${UIErrorMessage.FailedToGetDatasetMetadata} list`,
        true
      )
    };
  }

  public getScanParameter(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        UIErrorMessage.FailedToGetDatasetScanParameter,
        true
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        UIErrorMessage.MissingPermissionToGetDatasetScanParameter,
        true
      ),
      [ErrorStatus.NotFound]: ErrorMessage.create(
        UIErrorMessage.FailedToGetDatasetScanParameter,
        true
      ),
      [ErrorStatus.Conflict]: ErrorMessage.create(
        UIErrorMessage.FailedToGetDatasetScanParameter,
        true
      )
    };
  }

  public getMatchList(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        UIErrorMessage.FailedToGetDatasetMatchList,
        true
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        UIErrorMessage.MissingPermissionToGetDatasetMatchList,
        true
      ),
      [ErrorStatus.NotFound]: ErrorMessage.create(UIErrorMessage.FailedToGetDatasetMatchList, true)
    };
  }

  public startScan(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        UIErrorMessage.FailedToInitiateDatasetScan,
        true,
        false,
        [UIErrorMessage.FollowingParametersAreRequired]
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        UIErrorMessage.MissingPermissionToInitiateDatasetScan,
        true
      ),
      [ErrorStatus.NotFound]: ErrorMessage.create(UIErrorMessage.FailedToInitiateDatasetScan, true),
      [ErrorStatus.Conflict]: ErrorMessage.create(
        UIErrorMessage.FailedToInitiateDatasetScan,
        true,
        false,
        [UIErrorMessage.NpdbAnotherOneTimeQueryTriggered]
      )
    };
  }

  public getScan(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(UIErrorMessage.FailedToGetDatasetScan, true),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        UIErrorMessage.MissingPermissionToGetDatasetScan,
        true
      ),
      [ErrorStatus.NotFound]: ErrorMessage.create(UIErrorMessage.FailedToGetDatasetScan, true)
    };
  }

  public refreshScan(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        UIErrorMessage.FailedToRefreshDatasetScanVerification,
        true
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        UIErrorMessage.MissingPermissionToRefreshDatasetScan,
        true
      ),
      [ErrorStatus.NotFound]: ErrorMessage.create(
        UIErrorMessage.FailedToRefreshDatasetScanVerification,
        true
      ),
      [ErrorStatus.Conflict]: ErrorMessage.create(
        UIErrorMessage.FailedToRefreshDatasetScanVerification,
        true
      )
    };
  }

  public getScanList(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        `${UIErrorMessage.FailedToGetDatasetScan} list`,
        true
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        `${UIErrorMessage.MissingPermissionToGetDatasetMatchList} list`,
        true
      ),
      [ErrorStatus.NotFound]: ErrorMessage.create(
        `${UIErrorMessage.FailedToGetDatasetScan} list`,
        true
      )
    };
  }

  public patchMatch(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        UIErrorMessage.FailedToUpdateDatasetMatch,
        true
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        UIErrorMessage.MissingPermissionToUpdateDatasetMatch,
        true
      ),
      [ErrorStatus.NotFound]: ErrorMessage.create(UIErrorMessage.FailedToUpdateDatasetMatch, true),
      [ErrorStatus.Conflict]: ErrorMessage.create(UIErrorMessage.FailedToUpdateDatasetMatch, true)
    };
  }

  public aggregate(): ErrorStatusMapping {
    return {
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        UIErrorMessage.MissingPermissionToGetDatasetAggregation,
        true
      )
    };
  }
}

export const datasetError = new DatasetError();
